import { useState, useEffect,useContext } from "react";
import { TableContext } from "../context";
import axios from 'axios';
import { McDrawer } from "@maersk-global/mds-react-wrapper/components-core/mc-drawer";
import { McButton } from "@maersk-global/mds-react-wrapper/components-core/mc-button";
import { McLoadingIndicator } from "@maersk-global/mds-react-wrapper/components-core/mc-loading-indicator";
// import { DataGrid } from '@mui/x-data-grid';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Typography,
    Box,
    Card,
    CardContent
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { McLinkButton } from "@maersk-global/mds-react-wrapper/components-core/mc-link-button";

const maerskFontFamily = '"Maersk Text", -apple-system, BlinkMacSystemFont, "Microsoft JhengHei", "Microsoft Yahei", "微软雅黑", STXihei, "华文细黑", sans-serif';

function DeploymentDetailsDrawer({ isdrawerOpen, setisdrawerOpen, drawerCi, drawerCiCategory, drawerChange }) {
    const [drawerData, setDrawerData] = useState(null);
    const [drawerContent, setDrawerContent] = useState("");
    const [drawerHeading, setDrawerHeading] = useState("");
    const {getToken} = useContext(TableContext);
    const extractRepoName = (url) => {
        if (!url) return "";
        // Match after 'Maersk-Global/' and before the next '/'
        const match = url.match(/Maersk-Global\/([^/]+)/);
        return match ? match[1] : "";
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return 'NA';
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return 'NA';
        const pad = (n) => n.toString().padStart(2, '0');
        return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear().toString().slice(-2)} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    };

    const fetchData = async () => {
        setDrawerData(null);
        const repoName = extractRepoName(drawerCi);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URI}/api/change_data/getDeploymentDetails`,
                {
                    deployment_id: drawerChange,
                    repo_name: repoName,
                },
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("jwt_token"),
                    },
                }
            );
            
            if (response.data?.status === 200) {
                console.log("Deployment Details: ", response.data);
                const apiData = response.data;
                setDrawerData(apiData);
                setDrawerHeading('Deployment Details');
                setDrawerContent(
                    <div style={{ display: "flex", flexDirection: "column", padding: "4px" }}>
                        {/* Deployment Details */}
                        <div style={{ display: "flex", flexWrap: "wrap", marginBottom: "20px" }}>
                            {apiData.data?.deployment ? (
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "10px",
                                        width: "100%",
                                    }}
                                >
                                    <div>
                                        <span style={{ color: "#545454", fontSize: "1rem", fontWeight: "600" }}>Deployment ID</span>
                                        <input
                                            type="text"
                                            value={apiData.data.deployment?.id || 'NA'}
                                            disabled
                                            style={{
                                                fontSize: "1rem",
                                                borderRadius: "8px",
                                                border: "1px solid #e0e0e0",
                                                background: "#f7f7f7",
                                                padding: "8px 12px",
                                                color: "#222",
                                                outline: "none",
                                                width: "100%",
                                                boxSizing: "border-box",
                                                marginTop: "4px"
                                            }}
                                        />
                                    </div>

                                    {/* AI Analysis Card */}
                                    <Card
                                        style={{
                                            marginTop: '10px',
                                            marginBottom: '10px',
                                            background: '#E2F3FB',
                                            color: 'white',
                                            borderRadius: '12px',
                                            maxHeight: '300px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            boxShadow: 'none',
                                        }}
                                    >
                                        <CardContent style={{
                                            padding: '16px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            height: '100%',
                                            overflow: 'hidden'
                                        }}>
                                            <Box style={{ display: 'flex', alignItems: 'center', marginBottom: '12px', flexShrink: 0 }}>
                                                <AutoAwesomeIcon
                                                    style={{
                                                        marginRight: '8px',
                                                        fontSize: '20px',
                                                        color: '#545454'
                                                    }}
                                                />
                                                <Typography
                                                    style={{
                                                        fontWeight: '600',
                                                        color: '#545454',
                                                        margin: 0,
                                                        fontFamily: maerskFontFamily
                                                    }}
                                                >
                                                    AI Analysis
                                                </Typography>
                                            </Box>
                                            <Typography
                                                variant="body2"
                                                style={{
                                                    color: '#141414',
                                                    lineHeight: '1.6',
                                                    fontSize: '0.9rem',
                                                    overflowY: 'auto',
                                                    flex: 1,
                                                    paddingRight: '8px',
                                                    minHeight: 0,
                                                    fontFamily: maerskFontFamily
                                                }}
                                            >
                                                {(() => {
                                                    const aiAnalysis = apiData.data?.ai_analysis;
                                                    if (!aiAnalysis) return 'No AI Analysis Available';
                                                    
                                                    // Convert object to formatted JSX if it's an object
                                                    if (typeof aiAnalysis === 'object') {
                                                        return (
                                                            <div>
                                                                {Object.entries(aiAnalysis).map(([key, value], index) => {
                                                                    const formattedKey = key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                                                                    return (
                                                                        <div key={key} style={{ marginBottom: index < Object.entries(aiAnalysis).length - 1 ? '12px' : '0' }}>
                                                                            <div style={{ 
                                                                                fontWeight: 'bold', 
                                                                                color: '#545454',
                                                                                marginBottom: '4px'
                                                                            }}>
                                                                                {formattedKey}:
                                                                            </div>
                                                                            <div style={{ 
                                                                                whiteSpace: 'pre-wrap',
                                                                                wordBreak: 'break-word',
                                                                                color: '#141414'
                                                                            }}>
                                                                                {value}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        );
                                                    }
                                                    
                                                    return aiAnalysis.toString();
                                                })()}
                                            </Typography>
                                        </CardContent>
                                    </Card>

                                    <div>
                                        <span style={{ color: "#545454", fontSize: "1rem", fontWeight: "600" }}>SHA</span>
                                        <input
                                            type="text"
                                            value={apiData.data.deployment?.sha || 'NA'}
                                            disabled
                                            style={{
                                                fontSize: "1rem",
                                                borderRadius: "8px",
                                                border: "1px solid #e0e0e0",
                                                background: "#f7f7f7",
                                                padding: "8px 12px",
                                                color: "#222",
                                                outline: "none",
                                                width: "100%",
                                                boxSizing: "border-box",
                                                marginTop: "4px"
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <span style={{ color: "#545454", fontSize: "1rem", fontWeight: "600" }}>Created By</span>
                                        <input
                                            type="text"
                                            value={apiData.data.deployment?.created_by || 'NA'}
                                            disabled
                                            style={{
                                                fontSize: "1rem",
                                                borderRadius: "8px",
                                                border: "1px solid #e0e0e0",
                                                background: "#f7f7f7",
                                                padding: "8px 12px",
                                                color: "#222",
                                                outline: "none",
                                                width: "100%",
                                                boxSizing: "border-box",
                                                marginTop: "4px"
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <span style={{ color: "#545454", fontSize: "1rem", fontWeight: "600" }}>Created At</span>
                                        <input
                                            type="text"
                                            value={formatDate(apiData.data.deployment?.created_at)}
                                            disabled
                                            style={{
                                                fontSize: "1rem",
                                                borderRadius: "8px",
                                                border: "1px solid #e0e0e0",
                                                background: "#f7f7f7",
                                                padding: "8px 12px",
                                                color: "#222",
                                                outline: "none",
                                                width: "100%",
                                                boxSizing: "border-box",
                                                marginTop: "4px"
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <span style={{ color: "#545454", fontSize: "1rem", fontWeight: "600" }}>Environment</span>
                                        <input
                                            type="text"
                                            value={apiData.data.deployment?.latest_status?.environment || 'NA'}
                                            disabled
                                            style={{
                                                fontSize: "1rem",
                                                borderRadius: "8px",
                                                border: "1px solid #e0e0e0",
                                                background: "#f7f7f7",
                                                padding: "8px 12px",
                                                color: "#222",
                                                outline: "none",
                                                width: "100%",
                                                boxSizing: "border-box",
                                                marginTop: "4px"
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <span style={{ color: "#545454", fontSize: "1rem", fontWeight: "600" }}>Status</span>
                                        <input
                                            type="text"
                                            value={apiData.data.deployment?.latest_status?.state || 'NA'}
                                            disabled
                                            style={{
                                                fontSize: "1rem",
                                                borderRadius: "8px",
                                                border: "1px solid #e0e0e0",
                                                background: "#f7f7f7",
                                                padding: "8px 12px",
                                                color: "#222",
                                                outline: "none",
                                                width: "100%",
                                                boxSizing: "border-box",
                                                marginTop: "4px"
                                            }}
                                        />
                                    </div>
                                    <div style={{ marginTop: "10px" }}>
                                        <b style={{ color: "#545454", fontSize: "1rem", fontWeight: "600" }}>Log URL:</b>{" "}
                                        {apiData.data.deployment?.latest_status?.log_url ? (
                                            <a
                                                href={apiData.data.deployment.latest_status.log_url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: "#0077b2", marginLeft: 4 }}
                                            >
                                                View Logs
                                            </a>
                                        ) : "NA"}
                                    </div>
                                </div>
                            ) : (
                                <Typography>No data available</Typography>
                            )}
                        </div>

                        {/* Pull Request */}
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography>Pull Request</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {apiData.data?.pull_request ? (
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "10px",
                                            maxWidth: "100%",
                                            wordBreak: "break-word",
                                            overflowWrap: "break-word",
                                        }}
                                    >
                                        <div><b style={{ color: "#545454" }}>Number:</b> {apiData.data.pull_request.number || 'NA'}</div>
                                        <div><b style={{ color: "#545454" }}>Title:</b> {apiData.data.pull_request.title || 'NA'}</div>
                                        <div>
                                            <b style={{ color: "#545454" }}>Description:</b>
                                            {apiData.data.pull_request.description
                                                ? (
                                                    <span
                                                        style={{
                                                            display: "block",
                                                            whiteSpace: "pre-line",
                                                            marginLeft: 4,
                                                            maxWidth: "100%",
                                                            wordBreak: "break-word",
                                                            overflowWrap: "break-word",
                                                            overflowX: "auto"
                                                        }}
                                                    >
                                                        {apiData.data.pull_request.description}
                                                    </span>
                                                )
                                                : <span style={{ marginLeft: 4 }}>NA</span>
                                            }
                                        </div>
                                        <div><b style={{ color: "#545454" }}>Author:</b> {apiData.data.pull_request.author || 'NA'}</div>
                                        <div><b style={{ color: "#545454" }}>Created At:</b> {formatDate(apiData.data.pull_request.created_at)}</div>
                                        <div><b style={{ color: "#545454" }}>Closed At:</b> {formatDate(apiData.data.pull_request.closed_at)}</div>
                                        <div><b style={{ color: "#545454" }}>Merged At:</b> {formatDate(apiData.data.pull_request.merged_at)}</div>
                                        <div><b style={{ color: "#545454" }}>Merged By:</b> {apiData.data.pull_request.merged_by || 'NA'}</div>
                                    </div>
                                ) : (
                                    <Typography>No data available</Typography>
                                )}
                            </AccordionDetails>
                        </Accordion>

                        {/* Commits */}
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography>Commits</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {Array.isArray(apiData.data?.commits) && apiData.data?.commits?.length > 0 ? (
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", overflowX: "auto" }}>
                                        {apiData.data.commits
                                            .slice() // copy array
                                            .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)) // latest first
                                            .map((commit, idx, arr) => (
                                                <div key={commit.sha} style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
                                                    <Box
                                                        sx={{
                                                            background: "#E2F3FB",
                                                            border: "2px solid #222",
                                                            borderRadius: "8px",
                                                            padding: "12px 18px",
                                                            minWidth: 260,
                                                            maxWidth: 400,
                                                            margin: "0 auto",
                                                            boxShadow: 2,
                                                            marginBottom: 0,
                                                            position: "relative",
                                                            textAlign: "left",
                                                            wordBreak: "break-word",
                                                        }}
                                                    >
                                                        <div
                                                            title={commit.message}
                                                            style={{
                                                                fontWeight: 500,
                                                                marginBottom: 4,
                                                                fontSize: "1.05em",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                                maxWidth: 340,
                                                                cursor: "pointer",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            {commit.message.length > 30
                                                                ? `${commit.message.slice(0, 30)}...`
                                                                : commit.message}
                                                        </div>
                                                        <div style={{ fontSize: "0.95em", color: "#333", marginBottom: 2 }}>
                                                            <b>Author:</b> {commit.author_name || "NA"}
                                                        </div>
                                                        <div style={{ fontSize: "0.92em", color: "#333" }}>
                                                            <b>Timestamp:</b> {formatDate(commit.timestamp)}
                                                        </div>
                                                        <div style={{ fontSize: "0.85em", color: "#444", fontWeight: 600, marginBottom: 4 }}>
                                                            SHA: <span style={{ fontSize: "0.8em", color: "#888" }}>{commit.sha}</span>
                                                        </div>
                                                    </Box>
                                                    {idx < arr.length - 1 && (
                                                        <div style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            alignItems: "center",
                                                            height: 32,
                                                            marginBottom: 0
                                                        }}>
                                                            <div style={{
                                                                width: 2,
                                                                height: 24,
                                                                background: "#222"
                                                            }} />
                                                            <div style={{
                                                                width: 0,
                                                                height: 0,
                                                                borderLeft: "6px solid transparent",
                                                                borderRight: "6px solid transparent",
                                                                borderTop: "8px solid #222"
                                                            }} />
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                    </div>
                                ) : (
                                    <Typography>No data available</Typography>
                                )}
                            </AccordionDetails>
                        </Accordion>

                        {/* Approvals */}
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography>Approvals</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div style={{ width: "100%", overflowX: "auto" }}>
                                    {Array.isArray(apiData.data?.approvals) && apiData.data?.approvals?.length > 0 ? (
                                        <Table size="small" style={{ minWidth: 400, tableLayout: "auto", wordBreak: "break-word" }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell><b style={{ color: "#545454" }}>Reviewer</b></TableCell>
                                                    <TableCell><b style={{ color: "#545454" }}>Submitted At</b></TableCell>
                                                    <TableCell><b style={{ color: "#545454" }}>State</b></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {apiData.data.approvals.map((approval, idx) => (
                                                    <TableRow key={idx}>
                                                        <TableCell style={{ wordBreak: "break-word", maxWidth: 150 }}>{approval.reviewer || 'NA'}</TableCell>
                                                        <TableCell style={{ wordBreak: "break-word", maxWidth: 150 }}>{formatDate(approval.submitted_at)}</TableCell>
                                                        <TableCell style={{ wordBreak: "break-word", maxWidth: 100 }}>{approval.state || 'NA'}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    ) : (
                                        <Typography>No data available</Typography>
                                    )}
                                </div>
                            </AccordionDetails>
                        </Accordion>

                        {/* Review Comments */}
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography>Review Comments</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div style={{ width: "100%", overflowX: "auto" }}>
                                    {Array.isArray(apiData.data?.review_comments) && apiData.data?.review_comments?.length > 0 ? (
                                        <Table size="small" style={{ minWidth: 600, tableLayout: "auto", wordBreak: "break-word" }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell><b style={{ color: "#545454" }}>Reviewer</b></TableCell>
                                                    <TableCell><b style={{ color: "#545454" }}>File Path</b></TableCell>
                                                    <TableCell><b style={{ color: "#545454" }}>Comment</b></TableCell>
                                                    <TableCell><b style={{ color: "#545454" }}>Created At</b></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {apiData.data.review_comments.map((comment, idx) => (
                                                    <TableRow key={idx}>
                                                        <TableCell style={{ wordBreak: "break-word", maxWidth: 150 }}>{comment.reviewer || 'NA'}</TableCell>
                                                        <TableCell style={{ wordBreak: "break-word", maxWidth: 250 }}>{comment.path || 'NA'}</TableCell>
                                                        <TableCell style={{ wordBreak: "break-word", maxWidth: 350 }}>{comment.body || 'NA'}</TableCell>
                                                        <TableCell style={{ wordBreak: "break-word", maxWidth: 150 }}>{formatDate(comment.created_at)}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    ) : (
                                        <Typography>No data available</Typography>
                                    )}
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                );
            } else if (response.data?.message?.includes("No data found for the specified parameters")) {
                console.log("No details found for this Deployment");
                setDrawerData(["No details found for this Deployment"]);
                setDrawerHeading('Deployment Details');
                setDrawerContent(
                    <span>
                        No details found for this Deployment
                    </span>
                );
            } else {
                console.error('Failed to fetch Deployment details');
                toast.error("Failed to fetch Deployment details", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setDrawerHeading('Deployment Details');
                setDrawerContent(
                    <span>
                        No details found for this Deployment
                    </span>
                );
                setDrawerData(["No details found for this Deployment"]);
            }
        } catch (error) {
            console.error("Error fetching Deployment details", error);
            setDrawerData(["No details found for this Deployment"]);
            toast.error("Error fetching Deployment details", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            setDrawerHeading('Deployment Details');
            setDrawerContent(
                <span>
                    No details found for this Deployment
                </span>
            );
        }
    };

    const handleDrawerClose = () => {
        setisdrawerOpen(false);
        setDrawerContent("");
        setDrawerHeading("");
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <McDrawer
                open={isdrawerOpen}
                closed={handleDrawerClose}
            >
                <span slot="heading">
                    {drawerHeading}
                </span>

                {drawerData == null ? (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        <McLoadingIndicator appearance="primary"></McLoadingIndicator>
                    </div>
                ) : (
                    <>
                        <div style={{ marginTop: "10px" }}>{drawerContent}</div>
                        {/* <McButton
                            slot="footer"
                            dialogaction="close"
                            onClick={handleDrawerClose}
                        >
                            Close
                        </McButton> */}
                        <McLinkButton
                            slot="footer"
                            appearance="primary"
                            href={drawerCi}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ display: "flex", alignItems: "center" }}
                            onClick={() => { /* TODO: Add your full details handler here */ }}
                        >
                            <span style={{ display: "flex", alignItems: "center" }}>
                                Full Details
                                <span style={{ marginLeft: 6 }}>
                                    <mc-icon icon="square-arrow-up-right" size="20" color="white"></mc-icon>
                                </span>
                            </span>
                        </McLinkButton>
                    </>
                )}
            </McDrawer>

        </div>
    );
}

export default DeploymentDetailsDrawer;